export default __webpack_public_path__ + "static/media/paper_plane-success-graphic.e1bc1bef.svg";